import PTORequestExpandedContent from './PTORequestExpandedContent.component';

export default PTORequestExpandedContent;
